module.exports = __webpack_public_path__ + "static/media/2.dafcc24b.jpg";